import { render, staticRenderFns } from "./aml-policy.vue?vue&type=template&id=5a98f74a&"
import script from "./aml-policy.vue?vue&type=script&lang=js&"
export * from "./aml-policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports